// Select all elements with the class 'yourClassName'
var accordionEle = document.querySelectorAll('.footer-block .accordion-title');

// Add event listeners to each element
accordionEle.forEach(function (element) {
  // Ensure the element is focusable by adding tabindex if necessary
  if (!element.hasAttribute('tabindex')) {
    element.setAttribute('tabindex', '0');
  }

  // Add a click event listener
  element.addEventListener('click', function () {
    // Call your function when the element is clicked
    customAccordionToggle(this); // 'this' refers to the clicked element
  });

  // Add a keydown event listener for keyboard navigation
  element.addEventListener('keydown', function (event) {
    // Check if the 'Enter' key is pressed
    if (event.key === 'Enter' || event.keyCode === 13) {
      event.preventDefault(); // Prevent default action (scrolling or form submission)
      customAccordionToggle(this); // Call the same function as the click event
    }
  });
});

function customAccordionToggle(el, event) {
  const box = el.closest('.accordion-list');

  if (el.closest('.accordion-panel')) {
    if (el.classList.contains('active')) {
      this.closeAllSubPanels(el);
    } else {
      this.closeAllSubPanels(el);

      Array.from(box.children).forEach((panel) => {
        panel.classList.add('active');
        panel.querySelector('.accordion-panel').setAttribute('aria-hidden', false);
      });
      el.setAttribute('aria-expanded', true);
      el.classList.add('active');
    }
  }

  if (!el.closest('.accordion-panel')) {
    if (el.classList.contains('active')) {
      Array.from(box.children).forEach((panel) => {
        panel.classList.remove('active');
        if (panel.classList.contains('accordion-panel')) {
          panel.setAttribute('aria-hidden', true);
        }
      });

      el.classList.remove('active');
      el.setAttribute('aria-expanded', false);
    } else {
      document.querySelectorAll('.accordion-panel').forEach((panel) => {
        panel.classList.remove('active');
        panel.setAttribute('aria-hidden', true);
      });

      document.querySelectorAll('.accordion-title').forEach((title) => {
        title.classList.remove('active');
        title.setAttribute('aria-expanded', false);
      });

      Array.from(box.children).forEach((panel) => {
        panel.classList.add('active');
        if (panel.classList.contains('accordion-panel')) {
          panel.setAttribute('aria-hidden', false);
        }
      });
      el.setAttribute('aria-expanded', true);
      el.classList.add('active');
    }
  }
}

function closeAllSubPanels(el) {
  var accordionPanel = el.closest('.accordion-panel');

  // Using querySelectorAll to mimic jQuery's find() functionality
  var subPanels = accordionPanel.querySelectorAll('.accordion-panel');
  subPanels.forEach(function (subPanel) {
    subPanel.classList.remove('active');
    subPanel.querySelector('.accordion-panel').setAttribute('aria-hidden', true);
  });

  accordionPanel.querySelector('.accordion-title').classList.remove('active');
}
